import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from "rxjs";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  title = 'app';

    constructor(
      private router:Router
  ){ 
    this.router.events
    .takeUntil(this.ngUnsubscribe)
    .subscribe((e) => {
      if (e instanceof NavigationEnd) {
        console.log('app.component url: '+e.url); 
        //both of these work, but they scroll the entire window to the top.  not just the current component.
        // window.scrollTo(0, 0);
        // document.body.scrollTop = 0;
      }
    });
    
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
   }



}


//Unused code

//This didn't work.  The DOMLoad had already occured.  
// I instead load the javascript code dynamically through an http get,
// then write it into a script tag.  See 'bootstrap-relay.service.ts'.
// **alternatively, I could have just included the javascript file in the angular-cli.json
// and it would have been immediately avaialable.
// this.attachBootstrapRelay();
  // attachBootstrapRelay(){
  //   var script = document.createElement('script');
  //   document.body.appendChild(script);
  //   script.type = "text/javascript";
  //   script.src = "assets/bootstrapEventRelay.js";
  // }

// //This works!  will get the url route from within app.component
      // router.events.subscribe((e) => {
      //   if (e instanceof NavigationEnd) {
      //     console.log("app.component: NavigationEnd...");
      //     console.log(e.url);
      //   }
      // });


//* This only detects when the user navigates via the browser's url bar.  
//* However it doesn't update when you navigate to other components using router.navigate from within a component.
      // var pathString = location.path();
      // console.log('appComponent: pathString...');
      // console.log(pathString);       
//*This doesn't work:  Paramsmap example
    // let id = this.route.snapshot.paramMap.get('id');
    // console.log('app.component id:', id);
    // this.route.params.subscribe((params: Params) => {
    //   console.log('params', params);
    //   console.log('params.id:', params.id);
    // });


// WEBPACK FOOTER //
// ./src/app/app.component.ts